<template>
  <div>
    

    <div class="row">
      <div class="col-md-12 grid-margin">
        <div class="row">
          <div class="col-8 mb-0 mb-xl-0">
            <h4 class="mb-2">Custom Actions</h4>
            <h5 class="font-weight-bold"> Create and manage your custom actions</h5>
          </div>
          <div class="col-4">
            <button class="btn btn-md btn-success text-white font-weight-bold float-right" @click="openNewFunctionModal">
                  New Action
                </button>
          </div>
        </div>
      </div>
    </div>

    <div class="row mt-4">
      <div v-for="action in customActions" :key="action.uuid" class="col-md-4 mb-4">
        <div class="blockquote-primary">
          <div class="card-body">
            <div class="d-flex flex-column h-100">
              <div class="content-section">
                <h5 class="mb-2 text-truncate">{{ action.actionName }}</h5>
                <p class="text-muted description-text">{{ action.description }}</p>
              </div>
              <div class="action-buttons mt-auto">
                <div class="btn-group">
                  <router-link class="btn btn-sm btn-outline-primary mr-2" :to="'/custom-functions/' + action.uuid">
                    <i class="fa fa-edit"></i>
                  </router-link>
                  <button class="btn btn-sm btn-danger delete-btn text-white" @click="deleteAction(action.uuid)">
                    <i class="fa fa-trash"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- New Action Modal -->
    <div class="modal fade" id="newFunctionModal" tabindex="-1" role="dialog" aria-labelledby="newFunctionModalLabel" aria-hidden="true">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="newFunctionModalLabel">Create New Action</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <form @submit.prevent="createAction">
              <div class="form-group">
                <label class="col-form-label">Action Name:</label>
                <input type="text" class="form-control" v-model="newAction.actionName" required />
              </div>
              <div class="form-group">
                <label class="col-form-label">Description:</label>
                <textarea class="form-control" v-model="newAction.description" rows="2"></textarea>
              </div>
            </form>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-success text-white" @click="createAction">
              Create Action
            </button>
            <button type="button" class="btn btn-light" @click="closeModal">
              Cancel
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { useToast } from "vue-toastification";
import menuApi from "@/shared/menuApi";

export default {
  name: "CustomFunctionsList",
  setup() {
    const toast = useToast();
    return { toast };
  },
  data() {
    return {
      customActions: [],
      newAction: {
        actionName: "",
        description: "",
        code: ""
      }
    };
  },
  methods: {
    openNewFunctionModal() {
      this.newAction = {
        actionName: "",
        description: "",
        code: ""
      };
      jQuery("#newFunctionModal").modal("show");
    },
    closeModal() {
      jQuery("#newFunctionModal").modal("hide");
    },
    async createAction() {
      try {
        const response = await menuApi.doPost("/api/custom-action/create", this.newAction);
        if (response.status === "00") {
          this.toast.success("Custom action created successfully");
          this.closeModal();
          this.getCustomActions();
           //redirect to /custom-functions/
           this.$router.push(`/custom-functions/${response.uuid}`);
        } else {
          this.toast.error(response.message);
        }
      } catch (error) {
        this.toast.error(error.message || "Failed to create custom action");
      }
    },
    async deleteAction(uuid) {
      if (confirm("Are you sure you want to delete this action?")) {
        try {
          const response = await menuApi.doGet(`/api/custom-action/delete/${uuid}`);
          if (response.status === "00") {
            this.toast.success("Custom action deleted successfully");
            this.getCustomActions();
          } else {
            this.toast.error(response.message);
          }
        } catch (error) {
          this.toast.error(error.message || "Failed to delete custom action");
        }
      }
    },
    async getCustomActions() {
      try {
        const response = await menuApi.doGet("/api/custom-actions");
        if (response.status === "00") {
          this.customActions = response.data;
        } else {
          this.toast.error(response.message);
        }
      } catch (error) {
        this.toast.error(error.message || "Failed to fetch custom actions");
      }
    }
  },
  mounted() {
    this.getCustomActions();
  }
};
</script>

<style scoped>
.blockquote-primary {
  background: #23243a;
  border-radius: 8px;
  border: 1.5px solid #3444eb;
  transition: transform 0.2s, box-shadow 0.2s;
  box-shadow: 0 2px 8px rgba(30,34,90,0.08);
  height: 100%;
}

.blockquote-primary:hover {
  transform: translateY(-5px);
  box-shadow: 0 6px 16px rgba(30,34,90,0.18);
}

.card-body {
  height: 100%;
  padding: 1.25rem;
}

.content-section {
  flex: 1;
}

.description-text {
  margin-bottom: 0;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  min-height: 2.5em;
  line-height: 1.25;
}

.action-buttons {
  display: flex;
  justify-content: flex-end;
  padding-top: 1rem;
}

.btn-group {
  display: flex;
  gap: 0;
}

.delete-btn {
  border-left: 1px solid #ff4a4a;
  margin-left: 0;
}

.btn-sm {
  padding: 0.25rem 0.5rem;
  font-size: 0.875rem;
  line-height: 1.5;
  border-radius: 0.2rem;
}

.btn-outline-primary {
  color: #4a9eff;
  border-color: #4a9eff;
}

.btn-outline-primary:hover {
  background-color: #4a9eff;
  color: white;
}

.btn-outline-danger {
  color: #ff4a4a;
  border-color: #ff4a4a;
}

.btn-outline-danger:hover {
  background-color: #ff4a4a;
  color: white;
}

.text-muted {
  font-size: 0.875rem;
}

/* Ensure consistent spacing in the grid */
.row {
  margin-right: -15px;
  margin-left: -15px;
}

.col-md-4 {
  padding-right: 15px;
  padding-left: 15px;
}
</style> 